<template>
  <div
      :class="[
      'relative overflow-hidden rounded-xl p-6 backdrop-blur-md shadow-2xl',
      'border border-golden-grass/15 hover:border-golden-grass/35',
      'transition-colors duration-300',
      bgColor || 'bg-white/[0.03]',
    ]"
  >
    <!-- soft glow accent -->
    <div class="pointer-events-none absolute inset-0 opacity-50">
      <div class="absolute right-0 -bottom-10 h-48 w-48 rounded-full bg-golden-grass/10 blur-3xl"></div>
    </div>
    <h4 class="relative flex items-center gap-2.5 font-semibold mb-2 text-marshland-50">
      <span class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-golden-grass/10 text-golden-grass-400">
        <UIcon :name="icon" class="w-4.5 h-4.5" />
      </span>
      {{ title }}
    </h4>
    <p class="relative text-marshland-200/90">
      <slot>{{ description }}</slot>
    </p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  icon: string
  title: string
  description?: string
  bgColor?: string
}>()
</script>
